module.exports = __webpack_public_path__ + "images/faviconDot-c5ac34f93bc8d7239fd11e11f65e2f82.ico";